export default __webpack_public_path__ + "static/laptopBig.b3cd11f4.png";